<template>
  <vx-card title="Type Of Deductions">
    <div id="user-edit-tab-info">
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="vx-col w-full mb-base">
            <template>
              <vs-table
                stripe
                max-items="8"
                pagination
                search
                :data="getAllDeductionsType"
              >
                <template slot="thead">
                  <vs-th>Id</vs-th>
                  <vs-th>Code</vs-th>
                  <vs-th>Description</vs-th>
                  <vs-th>Category</vs-th>
                  <vs-th>Taxable?</vs-th>
                  <vs-th>Bonus?</vs-th>
                  <vs-th>YTD?</vs-th>
                  <vs-th>Add To?</vs-th>
                  <vs-th>Action</vs-th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr
                    :data="tr"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                  >
                    <vs-td :data="data[indextr].deductionsTypeId">
                      {{ data[indextr].deductionsTypeId }}
                    </vs-td>
                    <vs-td :data="data[indextr].deductionsTypeCode">
                      {{ data[indextr].deductionsTypeCode }}
                    </vs-td>
                    <vs-td :data="data[indextr].deductionsTypeName">
                      {{ data[indextr].deductionsTypeName }}
                    </vs-td>
                    <vs-td :data="data[indextr].deductionsCategoryId">
                      {{
                        deductionsCategory(data[indextr].deductionsCategoryId)
                          .deductionsCategoryName
                      }}
                    </vs-td>
                    <vs-td :data="data[indextr].isTaxable">
                      <vs-checkbox
                        v-model="data[indextr].isTaxable"
                        class="pointer-events-none"
                      />
                    </vs-td>
                    <vs-td :data="data[indextr].isBonus">
                      <vs-checkbox
                        v-model="data[indextr].isBonus"
                        class="pointer-events-none"
                      />
                    </vs-td>
                    <vs-td :data="data[indextr].isYTD">
                      <vs-checkbox
                        v-model="data[indextr].isYTD"
                        class="pointer-events-none"
                      />
                    </vs-td>
                    <vs-td :data="data[indextr].addTo">
                      {{ getAddToName(data[indextr].addTo).label }}
                    </vs-td>
                    <vs-td>
                      <!-- <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}" v-show="getDateDiff(data[indextr].createdOn) <= 10 ? true : false" > -->
                      <div :style="{ direction: $vs.rtl ? 'rtl' : 'ltr' }">
                        <feather-icon
                          icon="Edit3Icon"
                          svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                          @click="editRecord(data[indextr].deductionsTypeId)"
                        />
                        <feather-icon
                          icon="Trash2Icon"
                          svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
                          @click="
                            confirmDeleteRecord(data[indextr].deductionsTypeId)
                          "
                        />
                      </div>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </template>
          </div>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-button
            type="gradient"
            color="primary"
            @click="promptAddNewRecord()"
            icon-pack="feather"
            icon="icon-plus"
            >Add</vs-button
          >
        </div>
      </div>

      <!-- ADD EARNINGS TYPE -->
      <vs-prompt
        class="email-compose"
        title="Add Type of Deductions"
        accept-text="Submit"
        @accept="onAddNewRecord"
        :is-valid="validForm"
        :active.sync="activePromptAddRecord"
      >
        <vx-card title="Please fill-out the following information">
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Code</span>
              <span style="color: red">*</span>
              <vs-input
                name="code"
                v-validate="'required'"
                class="w-full"
                v-model="deductionsType.deductionsTypeCode"
              />
              <span class="text-danger text-sm" v-show="errors.has('code')">{{
                errors.first("code")
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Description</span
              ><span style="color: red">*</span>
              <vs-input
                name="name"
                v-validate="'required'"
                class="w-full"
                v-model="deductionsType.deductionsTypeName"
              />
              <span class="text-danger text-sm" v-show="errors.has('name')">{{
                errors.first("name")
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Category</span
              ><span style="color: red">*</span>
              <v-select
                name="deductions category"
                v-validate="'required'"
                class="w-full"
                v-model="deductionsCategoryName"
                label="deductionsCategoryName"
                :options="getAllDeductionsCategory"
                placeholder="Please Select"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('deductions category')"
                >{{ errors.first("deductions category") }}</span
              >
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-1/3 w-full mb-4">
              <div class="flex">
                <vs-checkbox v-model="deductionsType.isTaxable"
                  >Taxable?</vs-checkbox
                >
              </div>
            </div>
            <div class="vx-col sm:w-1/3 w-full mb-4">
              <div class="flex">
                <vs-checkbox v-model="deductionsType.isBonus"
                  >Bonus?</vs-checkbox
                >
              </div>
            </div>
            <div class="vx-col sm:w-1/3 w-full mb-4">
              <div class="flex">
                <vs-checkbox v-model="deductionsType.isYTD">YTD?</vs-checkbox>
              </div>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Add To?</span
              ><span style="color: red">*</span>
              <v-select
                name="add to"
                v-validate="'required'"
                class="w-full"
                v-model="addToName"
                :options="getAllAddTo"
                placeholder="Please Select"
              />
              <span class="text-danger text-sm" v-show="errors.has('add to')">{{
                errors.first("add to")
              }}</span>
            </div>
          </div>
        </vx-card>
      </vs-prompt>
      <!-- END ADD EARNINGS TYPE -->
      <!-- EDIT EARNINGS -->
      <vs-prompt
        class="email-compose"
        title="Edit Deductions"
        accept-text="Submit"
        @accept="onUpdateRecord"
        :is-valid="validForm"
        :active.sync="activePromptEditRecord"
      >
        <vx-card title="You may update the following information">
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Code</span>
              <span style="color: red">*</span>
              <vs-input
                :disabled="
                  getDateDiff(deductionsType.createdOn) <= 10 ? false : true
                "
                name="code"
                v-validate="'required'"
                class="w-full"
                v-model="deductionsType.deductionsTypeCode"
              />
              <span class="text-danger text-sm" v-show="errors.has('code')">{{
                errors.first("code")
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Description</span
              ><span style="color: red">*</span>
              <vs-input
                :disabled="
                  getDateDiff(deductionsType.createdOn) <= 10 ? false : true
                "
                name="name"
                v-validate="'required'"
                class="w-full"
                v-model="deductionsType.deductionsTypeName"
              />
              <span class="text-danger text-sm" v-show="errors.has('name')">{{
                errors.first("name")
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Category</span
              ><span style="color: red">*</span>
              <v-select
                name="deductions category"
                v-validate="'required'"
                class="w-full"
                v-model="deductionsCategoryName"
                label="deductionsCategoryName"
                :options="getAllDeductionsCategory"
                placeholder="Please Select"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('deductions category')"
                >{{ errors.first("deductions category") }}</span
              >
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-1/32 w-full mb-4">
              <div class="flex">
                <vs-checkbox v-model="deductionsType.isTaxable"
                  >Taxable?</vs-checkbox
                >
              </div>
            </div>
            <div class="vx-col sm:w-1/3 w-full mb-4">
              <div class="flex">
                <vs-checkbox v-model="deductionsType.isBonus"
                  >Bonus?</vs-checkbox
                >
              </div>
            </div>
            <div class="vx-col sm:w-1/3 w-full mb-4">
              <div class="flex">
                <vs-checkbox v-model="deductionsType.isYTD">YTD?</vs-checkbox>
              </div>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Add To?</span
              ><span style="color: red">*</span>
              <v-select
                name="add to"
                v-validate="'required'"
                class="w-full"
                v-model="addToName"
                :options="getAllAddTo"
                placeholder="Please Select"
              />
              <span class="text-danger text-sm" v-show="errors.has('add to')">{{
                errors.first("add to")
              }}</span>
            </div>
          </div>
        </vx-card>
      </vs-prompt>
      <!-- END EDIT EARNINGS -->
    </div>
  </vx-card>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import { en, he } from "vuejs-datepicker/src/locale";

import moment from "moment";
import vSelect from "vue-select";

import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Swal from "sweetalert2";
export default {
  data() {
    return {
      deductionsType: {
        deductionsTypeCode: "",
        deductionsTypeName: "",
        deductionsCategoryId: 1,
        addTo: 0,
        isTaxable: false,
        isBonus: false,
        isYTD: true,
        createdOn: "",
      },
      activePromptAddRecord: false,
      activePromptEditRecord: false,
    };
  },
  created() {
    this.$store.dispatch("lookup/getAllDeductionsCategory").catch((err) => {
      console.log(err);
    });
    this.$store.dispatch("lookup/getAllDeductionsType").catch((err) => {
      console.log(err);
    });
  },
  components: {
    "v-select": vSelect,
    Datepicker,
    flatPickr,
  },
  computed: {
    getAllDeductionsType() {
      return this.$store.state.lookup.getAllDeductionsType;
    },
    getAllDeductionsCategory() {
      return this.$store.state.lookup.getAllDeductionsCategory;
    },
    getAllAddTo() {
      return this.$store.state.lookup.addToLookup;
    },
    deductionsCategoryName: {
      get() {
        return this.$store.getters["lookup/deductionsCategoryLookup"](
          this.deductionsType.deductionsCategoryId
        );
      },
      set(obj) {
        this.deductionsType.deductionsCategoryId = obj.deductionsCategoryId;
      },
    },
    addToName: {
      get() {
        return this.$store.getters["lookup/addToLookup"](
          this.deductionsType.addTo
        );
      },
      set(obj) {
        this.deductionsType.addTo = obj.value;
      },
    },
    deductionsCategory() {
      return (id) => this.$store.getters["lookup/deductionsCategoryLookup"](id);
    },
    getAddToName() {
      return (id) => this.$store.getters["lookup/addToLookup"](id);
    },

    validForm() {},
    getDateDiff() {
      return (createdOn) => {
        var oneDay = 1;
        if (createdOn !== null && this.currentDate !== null) {
          var date1 = new Date(moment(createdOn).format("MM-DD-YYYY"));
          var date2 = new Date(moment(this.currentDate).format("MM-DD-YYYY"));

          var timeDiff = Math.abs(date2.getTime() - date1.getTime());
          var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
          if (diffDays !== "NaN") {
            return diffDays + oneDay;
          } else {
            return 0;
          }
        }
      };
    },
  },
  methods: {
    promptAddNewRecord() {
      this.activePromptAddRecord = true;
    },
    onAddNewRecord() {
      this.$vs.loading();
      this.$store
        .dispatch("lookup/addDeductionsType", this.deductionsType)
        .then((response) => {
          this.$vs.loading.close();
          if (response.status == 200)
            this.$alert("", "Save Successfully", "success");
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.$alert(error, "Error", "error");
        });
    },
    editRecord(id) {
      const e = this.$store.getters["lookup/deductionsTypeLookup"](id);

      (this.deductionsType.deductionsTypeId = id),
        (this.deductionsType.deductionsTypeCode = e.deductionsTypeCode),
        (this.deductionsType.deductionsTypeName = e.deductionsTypeName);
      (this.deductionsType.deductionsCategoryId = e.deductionsCategoryId),
        (this.deductionsType.isTaxable = e.isTaxable),
        (this.deductionsType.isBonus = e.isBonus),
        (this.deductionsType.isYTD = e.isYTD),
        (this.deductionsType.addTo = e.addTo);
      this.deductionsType.createdOn = e.createdOn;

      this.activePromptEditRecord = true;
    },
    onUpdateRecord() {
      this.$vs.loading();
      this.$store
        .dispatch("lookup/updateDeductionsType", this.deductionsType)
        .then((response) => {
          this.$vs.loading.close();
          if (response.status == 200)
            this.$alert("", "Updated Successfully", "success");
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.$alert(error, "Error", "error");
        });
    },
    confirmDeleteRecord(id) {
      Swal.fire({
        title: "Are you sure you want to <strong>continue</strong>?",
        text: "",
        icon: "warning",
        customClass: {
          icon: "no-before-icon",
        },
        showCancelButton: true,
        confirmButtonColor: "3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Confirm",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$vs.loading();
          this.$store
            .dispatch("lookup/deleteDeductionsType", id)
            .then((response) => {
              this.$vs.loading.close();
              if (response.status == 200) {
                this.$alert("", "Deleted Successfully", "success");
              }
            })
            .catch((error) => {
              this.$vs.loading.close();
              this.$alert(error, "Error", "error");
            });
        } else this.$alert("", "Cancelled Delete", "success");
      });
    },
  },
};
</script>

<style>
.vs-con-table .vs-con-tbody .con-vs-checkbox {
  justify-content: left !important;
}
</style>
